module.exports = __webpack_public_path__ + "static/media/mobile-menu-bg.507e478b.png";